import React from 'react';
import SelexSolNavbar from "./CommonC/SelexSolNavbar";



function SelexMSD() {
  return (
    <div>
        <SelexSolNavbar isLoggedIn={!!sessionStorage.getItem("usertoken")} />
         <iframe
      src="/SelexMSD_Web/index.html"
      width="100%"
      height="800px"
      style={{ border: "none" }}
      title="HTML Page"
    />
    </div>
  )
}

export default SelexMSD